import React from 'react'
import Typography from "@mui/material/Typography";

const Footer = () => {
     return (
          <div style={{ backgroundColor: 'black', width: '100%', display: 'flex', justifyContent: 'center' }}>
               <div style={{ width: '900px', textAlign: 'center', margin: '10px' }}>
                    <Typography variant="h5" component="div" sx={{ color: 'white' }}>
                         Privacy Policy Terms of Use Trust Center Safety Information
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ color: 'white' }}>
                         © 2024 Dexcom, Inc. All rights reserved. This product is covered by U.S. patent.
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ color: 'white' }}>
                         LBL016167 Rev001
                    </Typography>
               </div>
          </div>
     )
}

export default Footer